import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Star, Wrench } from 'lucide-react';
import { SocialIcon } from 'react-social-icons';

const styles = `
  .footer { background: #0a0a0a; border-top: 3px solid #c0392b; padding: 64px 0 0; }
  .footer-grid {
    max-width: 1180px; margin: 0 auto; padding: 0 24px;
    display: grid; grid-template-columns: 2fr 1fr 1fr; gap: 48px;
  }
  .footer-brand img { height: 70px; width: 70px; object-fit: contain; margin-bottom: 16px; }
  .footer-brand-name {
    font-family: 'Oswald', sans-serif; font-size: 1.2rem; font-weight: 700;
    letter-spacing: 0.06em; text-transform: uppercase; color: #fff; margin-bottom: 8px; display: block;
  }
  .footer-tagline { font-size: 0.88rem; color: #777; line-height: 1.65; max-width: 290px; margin-bottom: 20px; }
  .footer-contact { display: flex; align-items: center; gap: 10px; margin-bottom: 10px; font-size: 0.88rem; color: #888; }
  .footer-contact svg { color: #c0392b; flex-shrink: 0; }
  .footer-contact a { color: #888; transition: color 0.2s; text-decoration: none; }
  .footer-contact a:hover { color: #fff; }
  .footer-stars { display: flex; align-items: center; gap: 5px; margin-top: 16px; }
  .footer-stars span { font-size: 0.82rem; color: #888; margin-left: 4px; }
  .footer-social { display: flex; align-items: center; gap: 12px; margin-top: 20px; }
  .footer-col h4 {
    font-family: 'Oswald', sans-serif; font-size: 0.74rem; font-weight: 600;
    letter-spacing: 0.22em; text-transform: uppercase; color: #d4a017; margin-bottom: 18px;
  }
  .footer-col ul { list-style: none; padding: 0; margin: 0; }
  .footer-col ul li { margin-bottom: 10px; }
  .footer-col ul li a { font-size: 0.88rem; color: #777; transition: color 0.2s; text-decoration: none; }
  .footer-col ul li a:hover { color: #fff; }
  .footer-bottom {
    max-width: 1180px; margin: 0 auto; padding: 20px 24px; margin-top: 48px;
    border-top: 1px solid rgba(255,255,255,0.06);
    display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px;
  }
  .footer-bottom p { font-size: 0.8rem; color: #444; }
  .footer-tagline-bot { display: flex; align-items: center; gap: 6px; font-size: 0.8rem; color: #444; }
  .footer-tagline-bot svg { color: #c0392b; }
  @media (max-width: 768px) {
    .footer-grid { grid-template-columns: 1fr; gap: 32px; }
    .footer-bottom { flex-direction: column; text-align: center; }
  }
`;

export default function Footer() {
  return (
    <>
      <style>{styles}</style>
      <footer className="footer">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src="/logo.png" alt="Wengers Cycle Works" />
            <span className="footer-brand-name">Wengers Cycle Works</span>
            <p className="footer-tagline">Built on quality, precision, and real experience. Serving Lancaster County and beyond.</p>
            <div className="footer-contact">
              <Phone size={15} />
              <a href="tel:7172785897">(717) 278-5897</a>
            </div>
            <div className="footer-contact">
              <MapPin size={15} />
              <span>New Holland, PA</span>
            </div>
            <div className="footer-stars">
              {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="#d4a017" color="#d4a017" />)}
              <span>5-Star Rated</span>
            </div>
            <div className="footer-social">
              <SocialIcon
                url="https://www.facebook.com/p/Wengers-Cycle-Works-100083073679978/"
                style={{ height: 36, width: 36 }}
                target="_blank"
                rel="noopener noreferrer"
              />
            </div>
          </div>

          <div className="footer-col">
            <h4>Pages</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/parts">Parts</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services">V-Twin Repair</Link></li>
              <li><Link to="/services">Custom Builds</Link></li>
              <li><Link to="/services">Performance Work</Link></li>
              <li><Link to="/services">Engine Rebuilds</Link></li>
              <li><Link to="/parts">Parts Sourcing</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Wengers Cycle Works, New Holland, PA. All rights reserved.</p>
          <div className="footer-tagline-bot">
            <Wrench size={13} />
            Built on quality, precision &amp; real experience
          </div>
        </div>
      </footer>
    </>
  );
}
